import apiClient from '@/services/axios'

export async function get(venueDetailsId) {
  var params = { 'venue-details-id': venueDetailsId }
  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries', { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get venue setups')
}
